module.exports = "<svg class=\"nn-base-svg nn-base-svg--{{ icon }} {{ icon }}\"><use ng-attr-xlink:href=\"{{ '/assets/img/sprites.svg#' + icon }}\" xlink:href></use></svg>"


//////////////////
// WEBPACK FOOTER
// ./app/components/nn-base-components/nn-base-svg/nn-base-svg.directive.html
// module id = 960
// module chunks = 0